import axios from 'axios'
import * as types from '../mutation-types'

import { createTheParametersOfTheUrl } from '../../plugins/helper'

// state
export const state = {
  loadingPlanOfActions: true,
  planOfActions: [],
  errorPlanOfActions: {},
  loadingWeeklySchedule: true,
  weeklySchedule: [],
  errorWeeklySchedule: {},
}

const allPlanOfActions = (planOfActions) => {
  const term = []
  const temPlanOfActions = planOfActions.data || []
  if (temPlanOfActions && temPlanOfActions.length > 0) {
    Object.keys(temPlanOfActions).forEach(key => {
      const plan = temPlanOfActions[key]
      term.push({
        value: plan.id,
        text: plan.modelo,
      })
    })
  }

  return term
}

// mutations
export const mutations = {
  [types.GET_ACTION_PLAN_START] (state) {
    state.loadingPlanOfActions = true
    state.planOfActions = []
    state.errorPlanOfActions = {}
  },

  [types.GET_ACTION_PLAN_SUCCESS] (state, { data }) {
    state.loadingPlanOfActions = false
    // state.planOfActions = allPlanOfActions(data)
    state.planOfActions = allPlanOfActions(data)
    state.errorPlanOfActions = {}
  },

  [types.GET_ACTION_PLAN_ERROR] (state, { error }) {
    state.loadingPlanOfActions = false
    state.planOfActions = []
    state.errorPlanOfActions = error
  },

  [types.GET_CHECK_SCHEDULE_START] (state) {
    state.loadingWeeklySchedule = true
    state.weeklySchedule = []
    state.errorWeeklySchedule = {}
  },

  [types.GET_CHECK_SCHEDULE_SUCCESS] (state, { data }) {
    state.loadingWeeklySchedule = false
    state.weeklySchedule = data
    state.errorWeeklySchedule = {}
  },

  [types.GET_CHECK_SCHEDULE_ERROR] (state, { error }) {
    state.loadingWeeklySchedule = false
    state.weeklySchedule = []
    state.errorWeeklySchedule = error
  },
}

export const actions = {
  async getPlanOfActions ({ commit }, id) {
    try {
      commit(types.GET_ACTION_PLAN_START)

      const { data } = await axios.get(`/api/programming/${id}`)

      commit(types.GET_ACTION_PLAN_SUCCESS, { data })
    } catch (e) {
      const { response } = e
      commit(types.GET_ACTION_PLAN_ERROR, { error: response })
    }
  },

  async checkSchedule ({ commit }, { projectId, params }) {
    try {
      commit(types.GET_CHECK_SCHEDULE_START)
      const href = createTheParametersOfTheUrl(params)
      const { data } = await axios.get(`/api/projects/check_schedule/${projectId}${href}`)

      commit(types.GET_CHECK_SCHEDULE_SUCCESS, { data })
    } catch (e) {
      const { response } = e
      commit(types.GET_CHECK_SCHEDULE_ERROR, { error: response })
    }
  },
}

// getters
export const getters = {
  loadingPlanOfActions: state => state.loadingPlanOfActions,
  planOfActions: state => state.planOfActions,
  errorPlanOfActions: state => state.errorPlanOfActions,
  loadingWeeklySchedule: state => state.loadingWeeklySchedule,
  weeklySchedule: state =>  state.weeklySchedule,
  errorWeeklySchedule: state =>  state.errorWeeklySchedule,
}
